{
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    if(window.eHanlin.platform_env === undefined || window.eHanlin.platform_env === null){
        window.eHanlin.platform_env = {}
        window.eHanlin.platform_env.cdn = 'https://public.ehanlin.com.tw'
    }
    const createTemplate = (settings) => {
        let footerBgColor = settings.footerBgColor ? settings.footerBgColor : "#0D6CBE" ;
        let footerBgGradient = 'unset';
        if(settings.footerBgGradient) {
            footerBgColor = 'unset';
            footerBgGradient = settings.footerBgGradient;
        }
        return `
            <style>
                .mb-1{
                    margin-bottom: 12px;
                }
                .ml-1{
                    margin-left: 12px;
                }
                a {
                    text-decoration: none;
                }
                ul {
                    padding: 0
                }
                footer {
                    font-family: "Noto Sans TC", "Microsoft JhengHei", "PingFang TC", "Helvetica Neue", Arial, sans-serif;
                    -moz-user-select:none;
                    -webkit-user-select:none;
                    -ms-user-select:none;
                    user-select:none;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    color: #fff;
                    background-color: ${footerBgColor};
                    background-image: -webkit-gradient(${footerBgGradient});
                    background-image: ${footerBgGradient};
                    padding: 60px 0;
                }
                footer img {
                    width: auto
                }
                footer ul {
                    margin: 0
                }
                footer li {
                    list-style: none;
                    font-size: 12px
                }
                footer a {
                    color: #fff;
                    font-size: 12px
                }
                footer .item {
                    margin-right: 60px
                }
                footer .item:last-child {
                    margin-right: 0
                }
                @media screen and (max-width: 767px) {
                    footer {
                        -webkit-box-orient: vertical;
                        -webkit-box-direction: normal;
                        -ms-flex-direction: column;
                        flex-direction: column;
                        text-align: center
                    }
                    footer .item {
                        margin-right: 0;
                        margin-bottom: 24px
                    }
                    footer .item:last-child {
                        margin-bottom: 0
                    }
                }
            </style>
            <footer>
                <div class="item">
                    <ul>
                        <li class="mb-1">
                            <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/ehanlin-logo-white.svg">
                        </li>
                        <li>
                            <a href="https://www.facebook.com/ehanlin.com.tw/" target="_blank">
                                <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-fb.svg">
                            </a>
                            <a class="ml-1" href="https://www.ehanlin.com.tw/event/line/" target="_blank">
                                <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-line.svg">
                            </a>
                            <a class="ml-1" href="https://www.instagram.com/ehanlin.tw/" target="_blank">
                                <img src="${window.eHanlin.platform_env.cdn}/web/eh-footer/icon-ig.svg">
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="item">
                    <ul>
                        <li class="mb-1">服務時間</li>
                        <li>星期一至五 | 9:00至21:00<br>星期六/日及國定假日 | 休息</li>
                    </ul>
                </div>
                <div class="item">
                    <ul>
                        <li class="mb-1">客服專線</li>
                        <li><a href="tel:02-82282575">02-82282575</a></li>
                    </ul>
                </div>
            </footer>
            `;
    }
    customElements.define('eh-footer-simple', class extends HTMLElement {
        constructor(settings) {
            super();
            const shadowRoot = this.attachShadow({ mode: 'open' });
            shadowRoot.innerHTML = createTemplate(settings);
        }
    });
}
